import Cookies from 'universal-cookie';

export type AuthInfo = {
  email?: string | undefined;
  userId?: string | null;
  name?: string | null;
  accessToken?: string | null;
  idToken?: string | null;
  refreshToken?: string | null;
  expiry?: number | null; // ms since epoch
  refreshExpiry?: number | null; // ms since epoch
  user_type?: string | null;
  role?: string | null;
  requests?: string | null;
  email_verified?: string | null;
  phone_number_verified?: string | null;
  access_level?: string | null;
};

let store: AuthInfo = {};
const cookies = new Cookies();

export const getAuth = (): AuthInfo => {
  if (Object.keys(store).length === 0) {
    const cookieKeys = [
      'email',
      'userId',
      'name',
      'accessToken',
      'idToken',
      'refreshToken',
      'expiry',
      'refreshExpiry',
      'user_type',
      'email_verified',
      'phone_number_verified',
      'role',
      'requests',
      'access_level'
    ];
    cookieKeys.forEach((key) => {
      const value = cookies.get(key);
      if (value !== undefined) {
        store = { ...store, [key]: value };
      }
    });
  }
  return { ...store };
};

export const setAuth = (info: Partial<AuthInfo>) => {
  store = { ...store, ...info };
  Object.entries(info).forEach(([key, value]) => {
    cookies.set(key, value, { path: '/' });
  });
};

export const clearAuth = () => {
  Object.keys(store).forEach((key) => {
    cookies.remove(key, { path: '/' });
  });
  store = {};
};
